<template>
  <div class="container mt-5 px-4">
    <!-- Header Card -->
    <div class="header-card mb-4">
      <div class="d-flex align-items-center">
        <div class="icon-wrapper">
          <i class="bi bi-person-plus-fill"></i>
        </div>
        <div class="ms-3">
          <h3 class="mb-1 fw-bold">Create New User</h3>
          <p class="text-muted mb-0">Add a new user to your system</p>
        </div>
      </div>
    </div>

    <!-- Main Form Card -->
    <div class="form-card">
      <div class="row g-4">
        <!-- Left Section -->
        <div class="col-lg-6">
          <div class="form-section">
            <h5 class="section-title mb-4">
              <i class="bi bi-info-circle me-2"></i>Basic Information
            </h5>

            <div class="mb-4">
              <label class="custom-label">
                <i class="bi bi-person me-2"></i>Username
              </label>
              <input 
                type="text" 
                class="custom-input" 
                placeholder="Enter username" 
                v-model="username"
              >
            </div>

            <div class="mb-4">
              <label class="custom-label">
                <i class="bi bi-envelope me-2"></i>Email Address
              </label>
              <input 
                type="email" 
                class="custom-input" 
                placeholder="example@email.com" 
                v-model="email"
              >
            </div>

            <div class="row">
              <div class="col-md-6 mb-4">
                <label class="custom-label">
                  <i class="bi bi-card-text me-2"></i>First Name
                </label>
                <input 
                  type="text" 
                  class="custom-input" 
                  placeholder="First name" 
                  v-model="firstName"
                >
              </div>

              <div class="col-md-6 mb-4">
                <label class="custom-label">
                  <i class="bi bi-card-text me-2"></i>Last Name
                </label>
                <input 
                  type="text" 
                  class="custom-input" 
                  placeholder="Last name" 
                  v-model="lastName"
                >
              </div>
            </div>

            <div class="mb-4">
              <label class="custom-label">
                <i class="bi bi-shield-check me-2"></i>User Role
              </label>
              <select class="custom-input" v-model="role">
                <option value="" disabled selected>Select a role</option>
                <option value="User">User</option>
                <option value="Operator">Operator</option>
                <option value="Admin">Admin</option>
                <option value="Owner" v-if="['Owner'].includes(userInfo.role)">Owner</option>
              </select>
            </div>

            <div class="mb-4">
              <label class="custom-label">
                <i class="bi bi-lock me-2"></i>Password
              </label>
              <input 
                type="password" 
                class="custom-input" 
                placeholder="Enter secure password" 
                v-model="password"
              >
            </div>
          </div>
        </div>

        <!-- Right Section -->
        <div class="col-lg-6">
          <div class="form-section">
            <h5 class="section-title mb-4">
              <i class="bi bi-pencil-square me-2"></i>Additional Information
            </h5>

            <div class="mb-4">
              <label class="custom-label">
                <i class="bi bi-chat-left-text me-2"></i>Notes (Optional)
              </label>
              <textarea 
                class="custom-input" 
                rows="8" 
                placeholder="Add any additional notes about this user..." 
                v-model="note"
              ></textarea>
            </div>

            <!-- Info Box -->
            <div class="info-box">
              <i class="bi bi-lightbulb text-warning me-2"></i>
              <div>
                <strong>Quick Tip:</strong>
                <p class="mb-0 mt-1">Make sure to use a strong password with at least 8 characters including letters, numbers, and symbols.</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="button-row mt-5">
        <button @click="clearDataUser()" class="btn-clear">
          <i class="bi bi-arrow-counterclockwise me-2"></i>Clear Form
        </button>
        <button 
          @click="createUser()" 
          class="btn-create" 
          :disabled="!username || !firstName"
        >
          <i class="bi bi-check-circle me-2"></i>Create User
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      email: "",
      username: "",
      firstName: "",
      lastName: "",
      role: "",
      password: "",
      note: "",
      userInfo: {
        username: "",
        role: ""
      },
    };
  },
  methods: {
    clearDataUser() {
      this.email = "";
      this.username = "";
      this.firstName = "";
      this.lastName = "";
      this.role = "";
      this.password = "";
      this.note = "";
    },
    async createUser() {
      try {
        var accessToken = localStorage.getItem("accessToken");
        const response = await fetch(`${process.env.VUE_APP_API_URL}/auth/signup`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`
          },
          body: JSON.stringify({
            "username": this.username,
            "email": this.email,
            "password": this.password,
            "confirmPassword": this.password,
            "firstName": this.firstName,
            "lastName": this.lastName,
            "role": this.role
          })
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        this.$router.push('/settings/user/listuser');

        console.log('Dashboard page created:', result);
      } catch (error) {
        console.error('Error creating dashboard page:', error);
      }
    },
  },
  created() {
    this.userInfo.username = localStorage.getItem("username");
    this.userInfo.role = localStorage.getItem("role");
  }
}
</script>

<style scoped>
/* Header Card */
.header-card {
  background: linear-gradient(135deg, #66b3ea 0%, #4b68a2 100%);
  padding: 2rem;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(102, 126, 234, 0.15);
  color: white;
}

.icon-wrapper {
  width: 60px;
  height: 60px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.8rem;
  backdrop-filter: blur(10px);
}

.header-card h3 {
  color: white;
  margin: 0;
}

.header-card p {
  color: rgba(255, 255, 255, 0.9);
}

/* Form Card */
.form-card {
  background: white;
  padding: 2.5rem;
  border-radius: 16px;
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.06);
}

.form-section {
  height: 100%;
}

.section-title {
  color: #2d3748;
  font-weight: 600;
  font-size: 1.1rem;
  padding-bottom: 0.75rem;
  border-bottom: 2px solid #e2e8f0;
}

/* Custom Input Styles */
.custom-label {
  display: block;
  font-weight: 500;
  color: #4a5568;
  margin-bottom: 0.5rem;
  font-size: 0.95rem;
}

.custom-input {
  width: 100%;
  padding: 0.85rem 1rem;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  font-size: 0.95rem;
  transition: all 0.3s ease;
  background: #fafafa;
}

.custom-input:focus {
  outline: none;
  border-color: #667eea;
  background: white;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.custom-input::placeholder {
  color: #a0aec0;
}

textarea.custom-input {
  resize: vertical;
  min-height: 120px;
}

select.custom-input {
  cursor: pointer;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%234a5568' d='M6 9L1 4h10z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 1rem center;
  padding-right: 2.5rem;
}

/* Info Box */
.info-box {
  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
  padding: 1.25rem;
  border-radius: 10px;
  display: flex;
  align-items: flex-start;
  border-left: 4px solid #f59e0b;
}

.info-box i {
  font-size: 1.5rem;
  margin-top: 0.1rem;
}

.info-box strong {
  color: #92400e;
  display: block;
}

.info-box p {
  color: #78350f;
  font-size: 0.9rem;
}

/* Buttons */
.button-row {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  padding-top: 2rem;
  border-top: 2px solid #e2e8f0;
}

.btn-clear {
  padding: 0.85rem 2rem;
  border: 2px solid #e2e8f0;
  background: white;
  color: #718096;
  border-radius: 10px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
}

.btn-clear:hover {
  background: #f7fafc;
  border-color: #cbd5e0;
  color: #2d3748;
  transform: translateY(-1px);
}

.btn-create {
  padding: 0.85rem 2.5rem;
  border: none;
  background: linear-gradient(135deg, #6cbbe2 0%, #4ba295 100%);
  color: white;
  border-radius: 10px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  box-shadow: 0 4px 15px rgba(196, 196, 196, 0.3);
}

.btn-create:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(109, 109, 109, 0.4);
}

.btn-create:disabled {
  background: #cbd5e0;
  cursor: not-allowed;
  box-shadow: none;
}

/* Responsive */
@media (max-width: 991px) {
  .form-card {
    padding: 1.5rem;
  }
  
  .header-card {
    padding: 1.5rem;
  }
  
  .button-row {
    flex-direction: column-reverse;
  }
  
  .btn-clear,
  .btn-create {
    width: 100%;
    justify-content: center;
  }
}
</style>